(()=>{function initialize(){

(function(){
 'use strict';
 const root=document.getElementById('rb-collections-page');
 if(!root || root.dataset.ready==='yes') return;
 root.dataset.ready='yes';
 const buttons=[...root.querySelectorAll('[data-rb-language]')];
 const texts=[...root.querySelectorAll('[data-en][data-es]')];
 const menuBtn=root.querySelector('.rb-menu-toggle');
 const mobileNav=root.querySelector('.rb-mobile-nav');
 let currentLanguage='en';
 function closeMenu(){menuBtn.setAttribute('aria-expanded','false');mobileNav.hidden=true;}
 function setLanguage(code){
  currentLanguage=code==='es'?'es':'en';
  root.dataset.rbLocale=currentLanguage;
  root.lang=currentLanguage;
  texts.forEach(el=>{el.textContent=el.getAttribute('data-'+currentLanguage);});
  buttons.forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.rbLanguage===currentLanguage)));
  for(const link of root.querySelectorAll('[data-rb-go-home]')){
   const dest=link.getAttribute('data-rb-go-home');
   link.setAttribute('href','/?lang='+currentLanguage+'#'+dest);
  }
  menuBtn.setAttribute('aria-label',currentLanguage==='es'?'Abrir menú de navegación':'Open navigation menu');
  try{localStorage.setItem('rodrigo-blanco-home-language',currentLanguage)}catch(e){}
 }
 buttons.forEach(btn=>btn.addEventListener('click',()=>setLanguage(btn.dataset.rbLanguage)));
 menuBtn.addEventListener('click',()=>{
  const open=menuBtn.getAttribute('aria-expanded')!=='true';
  menuBtn.setAttribute('aria-expanded',String(open));mobileNav.hidden=!open;
  menuBtn.setAttribute('aria-label',open?(currentLanguage==='es'?'Cerrar menú de navegación':'Close navigation menu'):(currentLanguage==='es'?'Abrir menú de navegación':'Open navigation menu'));
 });
 mobileNav.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
 document.addEventListener('keydown',event=>{if(event.key==='Escape')closeMenu()});
 document.addEventListener('click',event=>{if(!mobileNav.hidden && !root.querySelector('.rb-site-header').contains(event.target) && !mobileNav.contains(event.target))closeMenu()});
 window.addEventListener('resize',()=>{if(window.innerWidth>1210)closeMenu()});
 let initial='en';
 try{if(localStorage.getItem('rodrigo-blanco-home-language')==='es')initial='es'}catch(e){}
 try{let query=new URLSearchParams(location.search).get('lang');if(query==='en'||query==='es')initial=query}catch(e){}
 setLanguage(initial);
})();


(function () {
 'use strict';
 const root=document.getElementById('rb-collections-page');
 const share=root?.querySelector('.rb-gallery-share-icon');
 const status=root?.querySelector('.rb-gallery-share-status');
 const dialog=root?.querySelector('.rb-gallery-share-dialog');
 const input=root?.querySelector('#rb-gallery-share-link');
 const close=root?.querySelector('.rb-gallery-share-close');
 const copyButton=dialog?.querySelector('.rb-gallery-copy-link');
 if(!root||!share||!status||!dialog||!input||!close||!copyButton||share.dataset.shareReady==='yes')return;
 share.dataset.shareReady='yes';
 let toastTimer=0,activationWasPointer=false;
 const tr=(en,es)=>root.dataset.rbLocale==='es'?es:en;
 function url(){
  const link=new URL('/pages/fine-art-collections','https://pbhh1s-xu.myshopify.com');
  link.searchParams.set('lang',root.dataset.rbLocale==='es'?'es':'en');
  return link.toString();
 }
 function feedback(){
  clearTimeout(toastTimer);
  status.textContent=tr('Page link copied','Enlace de la página copiado');status.hidden=false;
  toastTimer=setTimeout(()=>{status.hidden=true;},3200);
 }
 function restoreTriggerFocus(){
  if(!share.isConnected)return;
  if(activationWasPointer){

   if(document.activeElement===share)share.blur();
  }else{

   share.focus({preventScroll:true});
  }
 }
 async function copy(link){
  try{if(navigator.clipboard&&window.isSecureContext){await navigator.clipboard.writeText(link);return true;}}catch(_e){}
  const field=document.createElement('textarea');field.value=link;field.readOnly=true;
  field.setAttribute('aria-hidden','true');field.style.cssText='position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none';

  (dialog.open?dialog:root).appendChild(field);
  field.focus({preventScroll:true});field.select();field.setSelectionRange(0,field.value.length);
  let copied=false;try{copied=document.execCommand('copy');}catch(_e){}
  field.remove();return copied;
 }
 function manual(link){
  input.value=link;
  close.setAttribute('aria-label',tr('Close sharing options','Cerrar opciones para compartir'));
  dialog.showModal();input.focus({preventScroll:true});input.select();
 }
 share.addEventListener('click',async event=>{
  if(share.disabled)return;
  activationWasPointer=event.detail>0;
  const link=url();share.disabled=true;share.setAttribute('aria-busy','true');
  try{
   if(typeof navigator.share==='function'){
    try{await navigator.share({title:tr('Collections','Colecciones')+' | Rodrigo Blanco Photography',url:link});return;}
    catch(error){if(error&&error.name==='AbortError')return;}
   }
   if(await copy(link))feedback();else manual(link);
  }finally{
   share.disabled=false;share.removeAttribute('aria-busy');
   if(!dialog.open)restoreTriggerFocus();
  }
 });
 close.addEventListener('click',()=>dialog.close());
 dialog.addEventListener('close',restoreTriggerFocus);
 dialog.addEventListener('click',event=>{
  if(event.target!==dialog)return;const bounds=dialog.getBoundingClientRect();
  if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
 });
 copyButton.addEventListener('click',async()=>{
  if(await copy(input.value)){dialog.close();feedback();}else{input.focus({preventScroll:true});input.select();}
 });
 function updateLanguage(){
  share.setAttribute('aria-label',tr('Share this page','Compartir esta página'));
  close.setAttribute('aria-label',tr('Close sharing options','Cerrar opciones para compartir'));
  if(!status.hidden)status.textContent=tr('Page link copied','Enlace de la página copiado');
  if(dialog.open)input.value=url();
 }
 new MutationObserver(updateLanguage).observe(root,{attributes:true,attributeFilter:['data-rb-locale']});
 updateLanguage();
})();

}initialize();document.addEventListener('shopify:section:load',initialize);})();
(()=>{const root=document.querySelector("#rb-collections-page:not(.rb-unified-collection)");if(!root)return;const grid=root.querySelector(".rb-card-grid");if(!grid)return;const sort=()=>{const lang=root.dataset.rbLocale||"en";Array.from(grid.children).sort((a,b)=>(a.querySelector("h2")?.dataset[lang]||"").localeCompare(b.querySelector("h2")?.dataset[lang]||"",lang,{sensitivity:"base"})).forEach(card=>grid.appendChild(card));};new MutationObserver(sort).observe(root,{attributes:true,attributeFilter:["data-rb-locale"]});sort();})();
